export default {
    methods: {
        async getChildren(id) {
            if (!id) return [];
            const {data: children} = await this.$axios.get(`tree/${id}/children`);
            return children.map(item => ({
                value: item.id,
                label: item.nome
            }));
        },
    }
};
